/**
 * Política de contraseñas CMS AGDYSA.
 */

const WEAK_EXACT = new Set([
  "12345678",
  "87654321",
  "65432178",
  "123456789",
  "password",
  "password1",
  "qwerty12",
  "abcdefgh",
  "11111111",
  "00000000",
  "agdysa12",
  "agdysa123",
]);

export function isWeakPassword(password) {
  const p = String(password || "");
  if (p.length < 8) return true;
  const lower = p.toLowerCase();
  if (WEAK_EXACT.has(lower)) return true;
  if (/^\d+$/.test(p)) return true; // solo dígitos
  if (/^(.)\1+$/.test(p)) return true; // mismo carácter repetido
  if (/^(0123456789|9876543210)/.test(p) || /^(abcdef|qwerty)/i.test(p)) return true;
  // secuencias numéricas simples tipo 12345678 / 23456789
  if (/^\d{8,}$/.test(p)) {
    let asc = true;
    let desc = true;
    for (let i = 1; i < p.length; i++) {
      const d = Number(p[i]) - Number(p[i - 1]);
      if (d !== 1) asc = false;
      if (d !== -1) desc = false;
    }
    if (asc || desc) return true;
  }
  return false;
}

/** Contraseña definitiva: minúscula, mayúscula, número y carácter especial. */
export function getPasswordPolicyErrors(password) {
  const p = String(password || "");
  const errors = [];
  if (p.length < 8) errors.push("mínimo 8 caracteres");
  if (!/[a-z]/.test(p)) errors.push("al menos una minúscula");
  if (!/[A-Z]/.test(p)) errors.push("al menos una mayúscula");
  if (!/[0-9]/.test(p)) errors.push("al menos un número");
  if (!/[^A-Za-z0-9]/.test(p)) errors.push("al menos un carácter especial (!@#$%&*…)");
  if (isWeakPassword(p) && errors.length === 0) {
    errors.push("no use secuencias simples ni contraseñas obvias");
  }
  return errors;
}

export function isStrongPassword(password) {
  return getPasswordPolicyErrors(password).length === 0;
}

export const PASSWORD_POLICY_HINT =
  "Mín. 8 caracteres, con mayúscula, minúscula, número y carácter especial.";
